export default (state = [], action) => {
  switch (action.type) {
    case 'APP_HEALTH_MONITOR_DETAILS':
      return action.payload;
    default:
      return state;
  }
};
